import * as React from 'react';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import classNames from 'classnames';

import styles from './styles.pcss';

const UserTableHead = () => (
  <TableHead
    className={classNames(styles.tableHeadBoxShadow, styles.bbusersTable)}
  >
    <TableRow>
      <TableCell
        component="th"
        scope="row"
        className={styles.cellHide}
      ></TableCell>
      <TableCell className={styles.tableHead}>Name</TableCell>
      <TableCell className={styles.tableHead}>Email</TableCell>
      <TableCell className={styles.tableHead}>Role</TableCell>
      <TableCell className={styles.tableHead}>Status</TableCell>
      <TableCell
        component="th"
        scope="row"
        className={styles.cellHide}
      ></TableCell>
    </TableRow>
  </TableHead>
);

export default UserTableHead;
